import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid } from '@opari/ui/Grid';
import { IconPlus, IconPresent, IconSquarePlusDuplicate, IconVoucherGi, } from '@opari/ui/Icons';
import { Text } from '@opari/ui/Text';
import styled from 'styled-components';
import { useTranslation } from '../../../i18n';
import { useGiftsState } from '../../../store';
import { SelectedGiftPreview } from '../../SelectedGiftPreview';
import { Gifts } from './AddGifts';
import { AddGiftsItemWrapper } from './AddGifts.styled';
const AddButtonsWrap = styled(Grid) `
	margin-top: 10px;
`;
export const GiftsCtaSwitch = (props) => {
    const { selectedGiftCard, selectedGiftWrapping, showGiftCard, showGiftWrapping, showAccessories, onOpen, drawerId, simple, onDelete, onEdit: onEditProps, giftsEditable = true, } = props;
    const { active, setActive, setActiveDrawer, accesories, accessorySelected, setAccesories, } = useGiftsState();
    const t = useTranslation();
    const onEdit = (type) => {
        setActive(type);
        setActiveDrawer(drawerId);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen(type);
        if (selectedGiftCard) {
            onEditProps === null || onEditProps === void 0 ? void 0 : onEditProps(type);
        }
    };
    const getButton = (type) => {
        const isGiftCard = type === Gifts.CARDS;
        const isAccessory = type === Gifts.ACCESSORY;
        if ((!showGiftCard && isGiftCard) ||
            (!showGiftWrapping && !isGiftCard && !isAccessory) ||
            (!showAccessories && isAccessory)) {
            return null;
        }
        const gift = isGiftCard ? selectedGiftCard : selectedGiftWrapping;
        if (gift && type !== Gifts.ACCESSORY) {
            return (_jsx(SelectedGiftPreview, { showEditDelete: giftsEditable, gifts: [Object.assign(Object.assign({}, gift), { productType: type })], onEdit: onEdit, onDelete: () => {
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete(type, gift);
                } }));
        }
        if (!giftsEditable) {
            return null;
        }
        if (isAccessory && accessorySelected) {
            return (_jsx(SelectedGiftPreview, { gifts: accesories === null || accesories === void 0 ? void 0 : accesories.filter((a) => a.selected), onEdit: () => {
                    setActive(Gifts.ACCESSORY);
                    setActiveDrawer(drawerId);
                    onOpen === null || onOpen === void 0 ? void 0 : onOpen(Gifts.ACCESSORY);
                }, onDelete: (type, item) => {
                    const updated = accesories === null || accesories === void 0 ? void 0 : accesories.map((accessory) => {
                        if (accessory.id === item.id) {
                            return Object.assign(Object.assign({}, accessory), { selected: false, qty: 0 });
                        }
                        return accessory;
                    });
                    updated && setAccesories(updated);
                } }));
        }
        return (_jsx("button", { type: "button", onClick: () => {
                onEdit(type);
            }, children: _jsxs(AddGiftsItemWrapper, { active: type === active && simple, gap: "xs", alignItems: "center", children: [_jsx(IconPlus, { size: 15 }), isGiftCard ? (_jsx(IconVoucherGi, {})) : isAccessory ? (_jsx(IconSquarePlusDuplicate, {})) : (_jsx(IconPresent, {})), _jsx(Text, { textAlign: "left", children: t(isGiftCard
                            ? 'productPage.gifts.addGiftCards'
                            : isAccessory
                                ? 'productPage.gifts.addAccessories'
                                : 'productPage.gifts.addGiftWrappings') })] }) }));
    };
    return selectedGiftCard && selectedGiftWrapping ? (_jsxs(_Fragment, { children: [_jsx(SelectedGiftPreview, { gifts: [
                    Object.assign(Object.assign({}, selectedGiftWrapping), { productType: 'giftWrapping' }),
                    Object.assign(Object.assign({}, selectedGiftCard), { productType: 'giftCard' }),
                ], showEditDelete: giftsEditable, onEdit: onEdit, onDelete: (type, gift) => {
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete(type, gift);
                } }), showAccessories && (_jsx(AddButtonsWrap, { gap: "xs", columns: selectedGiftCard || selectedGiftWrapping ? [] : ['1fr', '1fr 1fr'], children: getButton(Gifts.ACCESSORY) }))] })) : (_jsxs(AddButtonsWrap, { gap: "xs", columns: accessorySelected || selectedGiftCard || selectedGiftWrapping
            ? []
            : ['1fr', '1fr 1fr'], children: [getButton(Gifts.WRAPPING), getButton(Gifts.CARDS), getButton(Gifts.ACCESSORY)] }));
};
//# sourceMappingURL=GiftsCtaSwitch.js.map